<template>
    <div style="display: flex; flex-direction: column;padding: 5px;">
        <div v-for="(file, index) in fileList" :key="index" style="padding: 5px 0;">
            <el-link :underline="false" @click="handleFilePreview(file)">{{file.name||file.filename}}</el-link>
            <el-link :underline="false" type="primary" style="margin-left: 10px; color: red;" @click="handleDelete(file, index)">删除</el-link>
        </div>
        <el-upload
            class="product-upload"
            :action="action"
            :on-preview="handleFilePreview"
            :before-upload="handleFileBeforeUpdate"
            :on-success="handleFileUploadSuccess"
            :on-error="handleFileUploadError"
            multiple
            drag
            :data="uploadData"
            :show-file-list="false">
<!--            <el-button size="small" type="primary" icon="el-icon-upload">上传文件</el-button>-->
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
    </div>
</template>

<script>
export default {
    name: "FileUpload",
    props: {
        action: String,
        fileList: {
            type: Array,
            default: []
        },
        onDelete: {
            type: Function,
            default: ()=>{}
        },
        onUploadSuccess: {
            type: Function,
            default: (response, file, fileList)=>{}
        },
        beforeUpload: {
            type: Function,
            default: ()=>{return Promise.resolve(true)}
        },
        uploadData: {
            type: Object,
            default: {}
        }
    },
    data()
    {
        return {}
    },
    methods:
    {
        handleFilePreview(file)
        {
            console.log("handleFilePreview", file);
            window.open(file.url);
        },
        handleFileBeforeUpdate(file)
        {
            return this.beforeUpload(file);
        },
        handleFileUploadSuccess(response, file, fileList)
        {
            return this.onUploadSuccess(response, file, fileList);
        },
        handleFileUploadError(err, file, fileList)
        {
            return this.showMessageError("上传失败: "+err.message);
        },
        handleDelete(file, index)
        {
            return this.onDelete(file, index);
        }


    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/FileUpload.vue